import React from 'react';
import { Tooltip, FormControl, Select, MenuItem, Stack, Typography, CircularProgress, SelectChangeEvent } from '@mui/material';
import { Division } from '../glossary/glossary.type';
import { TOOLTIPS } from '../report/report.util';
import { ReportStatusEnum } from '../report/report.type';

interface ButtonStyledDropdownProps {
  divisions: Division[];
  selectedLineItems: unknown[]; // You can replace with ReportLineItem[] if needed
  division: Division | null;
  loadingDivisionId?: string | null;
  isLocked: boolean;
  reportStatus?: string;
  onSelect: (divisionId: string) => void;
}

const ButtonStyledDropdown: React.FC<ButtonStyledDropdownProps> = ({
  divisions,
  selectedLineItems,
  division,
  loadingDivisionId,
  isLocked,
  reportStatus,
  onSelect,
}) => {
  const isDisabled = isLocked || selectedLineItems.length === 0 || divisions.length <= 1;
  return (
    <Tooltip
      title={isLocked && reportStatus === ReportStatusEnum.Completed ? TOOLTIPS.statusCompleted : isLocked ? TOOLTIPS.unlockToEdit : ''}
      arrow={false}
    >
      <span>
        <FormControl size='small' sx={{ minWidth: 160 }}>
          <Select
            displayEmpty
            value=''
            onChange={(e: SelectChangeEvent) => onSelect(e.target.value)}
            disabled={isDisabled}
            renderValue={() => (
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '0.75rem',
                  color: '#0283a0',
                  textAlign: 'center',
                  letterSpacing: '0.02857em',
                }}
              >
                MOVE DIVISION
              </Typography>
            )}
            sx={{
              height: 40,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '0.75rem',
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              fontWeight: 700,
              backgroundColor: isLocked ? theme => theme.palette.action.disabledBackground : 'transparent',
              border: theme => (isDisabled ? `1px solid ${theme.palette.action.disabled}` : `1px solid ${theme.palette.primary.main}`),
              color: theme => (isDisabled ? theme.palette.text.disabled : theme.palette.primary.main),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '& .MuiSelect-select': {
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              },
              '& .MuiSelect-icon': {
                color: theme => (isDisabled ? theme.palette.text.disabled : theme.palette.primary.main),
                right: 8,
              },
              '& fieldset': {
                border: 'none',
              },
            }}
          >
            {divisions
              .filter(div => div.id !== division?.id)
              .map(div => (
                <MenuItem key={div.id} value={div.id}>
                  <Stack direction='row' alignItems='center' spacing={1}>
                    <Typography variant='body2'>
                      {div.code} - {div.name}
                    </Typography>
                    {loadingDivisionId === div.id && <CircularProgress size={16} thickness={5} />}
                  </Stack>
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </span>
    </Tooltip>
  );
};

export default ButtonStyledDropdown;
